import { PredictiveAnalytics } from "@/components/PredictiveAnalytics";

const PredictiveAnalyticsPage = () => {
  return <PredictiveAnalytics />;
};

export default PredictiveAnalyticsPage;